import React from 'react';

interface TextNode {
  type: 'text';
  text: string;
}

interface LinkNode {
  type: 'link';
  url: string;
  children: TextNode[];
}

type CMSRenderNodes = TextNode | LinkNode;

export type CMSType = CMSRenderNodes[];

export const labelRenderer = (
  paragraph: CMSType,
  variables: { [key: string]: string }
): JSX.Element => {
  const renderChild = (child: TextNode | LinkNode) => {
    if (child.type === 'text') {
      const text = child.text.replace(/\${(.*?)}/g, (_, g) => variables[g] || '');
      return text;
    } else if (child.type === 'link') {
      return (
        <a href={child.url} target="_blank">
          {child.children.map((child, index) => (
            <React.Fragment key={index}>{renderChild(child)}</React.Fragment>
          ))}
        </a>
      );
    }
    return null;
  };

  return (
    <label htmlFor="gwp-checkbox">
      {paragraph.map((child: TextNode | LinkNode, index) => (
        <React.Fragment key={index}>{renderChild(child)}</React.Fragment>
      ))}
    </label>
  );
};
